export default () => ({
  root: {
    padding: 20
  }
});